module.exports = __webpack_public_path__ + "static/media/dataLovers.bfc31526.png";